export enum CategoryTypeEnum {
    Clinical = 1,
    Proffessional = 2
}

export enum CategoryActionEnum {
    AddCategory = 0,
    EditCategory = 1,
    AddSubCategory = 2,
    EditSubCategory = 3
}

export enum SubCategoryTypes {
    BookedDays = 174
}
